module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_edit-65c5c86e093ef6fcd5700f20177f3b4d.svg";